<template>
  <div ref="container">
    <a-modal
      :title="title"
      :width="800"
      :visible="visible"
      :confirmLoading="confirmLoading"
      :maskStyle="{'top':'93px','left':'154px'}"
      :wrapClassName="wrapClassNameInfo()"
      :mask="false"
      :maskClosable="false"
      @ok="handleOk"
      @cancel="handleCancel"
      cancelText="取消"
      okText="保存"
      style="top:5%;height: 90%;"
      >
      <template slot="footer">
        <a-button key="back" v-if="isReadOnly" @click="handleCancel">
          取消
        </a-button>
      </template>

        <a-form :form="form" >

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="节点名称">
            <a-input placeholder="请输入节点名称" v-decorator.trim="['nodeNameX', validatorRules.nodeNameX]"/>
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="节点编码">
            <a-input placeholder="请输入节点编码" v-decorator.trim="['nodeCode', validatorRules.nodeCode]"/>
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否作为前缀">
            <a-radio-group v-decorator.trim="[ 'ifInIdcode', validatorRules.ifInIdcode]">
              <a-radio value="0">否</a-radio>
              <a-radio value="1">是</a-radio>
            </a-radio-group>
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="节点前置分隔符" v-if="this.delimiter">
            <a-radio-group v-decorator.trim="[ 'delimiter', validatorRules.delimiter]" @change="delimiterC">
              <a-radio-button v-for="item in delimiter" :key="item.value" :value="item.value">{{ item.label }}</a-radio-button>
            </a-radio-group>
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="节点类型" v-if="this.nodeStyle">
            <a-select v-decorator.trim="['nodeStyle', validatorRules.nodeStyle]" @change="nodeType">
              <a-select-option v-for="(item,index) in nodeStyle" :key="item.value" :value="item.value">{{item.label}}</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="节点长度" v-if="this.isShow === '1' || this.isShow === '5' || this.model.nodeStyle === '1' || this.model.nodeStyle === '5'">
            <a-input placeholder="请输入节点长度" v-decorator.trim="[ 'nodeLength', validatorRules.nodeLength ]"/>
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="常量" v-if="this.isShow === '0' || this.model.nodeStyle === '0'">
            <a-input placeholder="请输入节点编码" v-decorator.trim="[ 'value', validatorRules.value]"/>
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="日期格式" v-if="this.isShow === '2' || this.isShow === '6' || this.model.dateFormat || this.model.nodeStyle === '2' || this.model.nodeStyle === '6'">
            <a-radio-group v-decorator.trim="[ 'dateFormat', validatorRules.dateFormat]">
              <a-radio-button v-for="item in dateFormat" :key="item.value" :value="item.value">{{ item.label }}</a-radio-button>
            </a-radio-group>
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="关联字典ID" v-show="this.dictId && this.isShow === '4' || this.isShow === '3' || this.model.dictId">
            <a-select v-decorator.trim="[ 'dictId', validatorRules.dictId]" @change="dictIdE">
              <a-select-option v-for="(item,index) in dictId" :key="item.uuid" :value="item.uuid">{{item.dictName}}</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
            <a-textarea placeholder="请输入备注" :auto-size="{ minRows: 3, maxRows: 5 }" v-decorator.trim="[ 'remark', validatorRules.remark]"/>
          </a-form-item>
        </a-form>
    </a-modal>
  </div>
</template>
<script>
  import pick from 'lodash.pick'
  import {addFunction,editFunction,checkFunction, checkNumber } from '@/api/api'
  import {autoJumpNextInput} from "@/utils/util"
  import {mixinDevice} from '@/utils/mixin'
  import JSelectMultiple from '@/components/jeecg/JSelectMultiple'
  import { queryEnableDictItemsByCode, queryDictItemsByType, queryDictDataByDictId, addRuleNode, editRuleNode } from '@/api/identifierCode/identifierCode'
  export default {
    name: "ruleNodeModal",
    mixins: [mixinDevice],
    components: {
      JSelectMultiple
    },
    props: {
      uuid: { type: Array, required: true }
    },
    data () {
      return {
        title:"操作",
        visible: false,
        model: {},
        enabledSwitch: true, //是否启用
        isReadOnly: false,
        jselectMultiple: {
          options: [
            { text: '编辑', value: '1' },
            { text: '审核', value: '2' },
            { text: '反审核', value: '7' },
            { text: '导出', value: '3' },
            { text: '启用禁用', value: '4' },
            { text: '打印', value: '5' },
            { text: '作废', value: '6' }
          ],
          value: ''
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        form: this.$form.createForm(this),
        validatorRules:{
          nodeLength:{
            rules: [
              { required: true, message: '请输入节点长度！' }
            ]
          },
          nodeNameX: {
            rules: [
              { required: true, message: '请输入节点名称！' }
            ]
          },
          nodeCode: {
            rules: [
              { required: true, message: '请输入节点编码！' }
            ]
          },
          ifInIdcode: {
            rules: [
              { required: true, message: '请选择是否作为前缀！' }
            ]
          },
          delimiter: {
            rules: [
              { required: true, message: '请选择节点前置分隔符！' }
            ]
          },
          nodeStyle: {
            rules: [
              { required: true, message: '请选择节点类型！' }
            ]
          },
          dateFormat: {
            rules: [
              { required: true, message: '请选择日期格式！' }
            ]
          }
        },
        // 下拉框数据
        delimiter: [], // 节点前置分隔符
        nodeStyle: [], // 节点类型
        dateFormat: [], // 日期格式
        dictId: [], // 关联字典ID
        dictDataId: null, // 字典具体值

        isShow: null,
        isShowC: null,
        ruleId: null,
        qveH: null
      }
    },
    created () {
    },
    methods: {
      onChange(checked) {
        this.model.enabled = checked
      },
      add (qve) {
        console.log('我！！！', qve)
        this.ruleId = qve.ruleId
        this.edit({});
        this.model.enabled = true
        this.enabledSwitch = true
      },
      async edit (record) {

        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        if(record.enabled!=null){
          this.enabledSwitch = record.enabled?true:false;
        }
        if(this.model.uuid){
          this.jselectMultiple.value = record.pushBtn
        } else {
          this.jselectMultiple.value = ''
        }
        if ( this.model.nodeId ) {
          this.model.uuid = this.model.nodeId
        }
        this.$nextTick(() => {
          this.model.nodeNameX = this.model.nodeName
          this.form.setFieldsValue(pick(this.model, 'nodeNameX', 'nodeCode', 'ifInIdcode', 'delimiter', 'nodeStyle', 'nodeLength', 'value', 'dateFormat', 'dictId', 'dictDataId', 'remark'))
          // autoJumpNextInput('ruleNodeModal')
        });
        console.log("🚀 ~ this.$nextTick ~ model:", this.model)


        // 获取节点前置分隔符
        await queryEnableDictItemsByCode({code: 'Nodeleadingdelimiter'})
        .then(res => {
          this.delimiter = res
        })

        // 获取日期格式
        await queryEnableDictItemsByCode({code: 'date_format'})
        .then(res => {
          this.dateFormat = res
        })

        let nodeType2
        if ( this.model.nodeStyle === '4' ) {
          // 自定义字典
          nodeType2 = '1'
        } else {
          // 标准字典
          nodeType2 = '0'
        }

        // 获取字典ID
        await queryDictItemsByType({nodeType: nodeType2})
        .then(res => {
          this.dictId = res.result
          console.log('===', this.dictId)
        })

        // 获取字典具体值
        if(this.model.dictId){
          await queryDictDataByDictId({dictId: this.model.dictId})
            .then(res => {
              this.dictDataId = res.result
              console.log('字典具体值', this.dictDataId)
            })
        }
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let formData = Object.assign(this.model, values);
            formData.pushBtn = this.jselectMultiple.value
            formData.ruleId = this.ruleId
            if ( this.qveH ) {
              formData.value = this.qveH
            }
            let obj;
            console.log('查看', this.model)
            formData.nodeName = formData.nodeNameX
            if(!this.model.nodeId){
              obj=addRuleNode(formData);

            }else{
              obj=editRuleNode(formData);
            }
            obj.then((res)=>{
              if(res.code === 200){
                this.isShow = null
                this.isShowC = null
                that.confirmLoading = false;
                that.close();
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
                that.confirmLoading = false;
              }
            })
          }
        })
      },
      handleCancel () {
        this.close()
      },
      validateNumber(rule, value, callback){
        let params = {
          number: value,
          id: this.model.id?this.model.id:0
        };
        checkNumber(params).then((res)=>{
          if(res && res.code===200) {
            if(!res.data.status){
              callback();
            } else {
              callback("编号已经存在！");
            }
          } else {
            callback(res.data);
          }
        });
      },
      validateName(rule, value, callback){
        let params = {
          name: value,
          id: this.model.id?this.model.id:0
        };
        checkFunction(params).then((res)=>{
          if(res && res.code===200) {
            if(!res.data.status){
              callback();
            } else {
              callback("名称已经存在！");
            }
          } else {
            callback(res.data);
          }
        });
      },
      onSearchParentNumber() {
        this.$refs.functionTreeModal.edit(this.model.id);
        this.$refs.functionTreeModal.title = "选择上级编号";
        this.$refs.functionTreeModal.disableSubmit = false;
      },
      functionTreeModalOk(number, name) {
        this.form.setFieldsValue({'parentNumber': number, 'parentName': name})
      },

      // 节点类型 - 变化事件
      nodeType(qve) {
        let nodeType

        console.log('====>>>',qve)
        if ( qve === '4' ) {
          // 自定义字典
          nodeType = '1'
        } else {
          // 标准字典
          nodeType = '0'
        }
        // 获取字典ID
        queryDictItemsByType({nodeType: nodeType})
        .then(res => {
          this.dictId = res.result
          console.log('===', this.dictId)
        })

        this.isShow = qve
        let newuuid = this.model.uuid
        let newnodeId = this.model.nodeId

        this.model = {}
        this.model = {
          uuid: newuuid,
          nodeId: newnodeId
        }
      },
      // 字典ID - 变化事件
      dictIdE(qve) {
        console.log('===', qve)
        // 获取字典具体值
        queryDictDataByDictId({dictId: qve})
        .then(res => {
          this.dictDataId = res.result
          console.log('字典具体值', this.dictDataId)
        })
      },
      // 节点前置分隔符 - 变化事件
      delimiterC(qve) {
        this.isShowC = qve
      },
      dictDataIdE(value) {
        console.log('这是啥？', value.target.value)


        let foundObject = this.dictDataId.find(item => item.uuid === value.target.value);

        if (foundObject) {
          console.log('找到了对象，其dictValue是：', foundObject.dictValue);
          this.qveH = foundObject.dictValue
        } else {
          console.log('没有找到具有指定uuid的对象。');
        }
      }
    },
    created() {
      // 获取节点前置分隔符
      queryEnableDictItemsByCode({code: 'Nodeleadingdelimiter'})
      .then(res => {
        this.delimiter = res
      })
      // 获取节点类型
      queryEnableDictItemsByCode({code: 'node_type'})
      .then(res => {
        this.nodeStyle = res
      })
      // 获取日期格式
      queryEnableDictItemsByCode({code: 'date_format'})
      .then(res => {
        this.dateFormat = res
      })
    }
  }
</script>
<style scoped>

</style>